import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LanguageService, languages } from '../../services/language.service';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { LoggerService } from '../../sdk';

@Component({
  selector: 'app-language-dropdown',
  templateUrl: './language-dropdown.component.html',
  styleUrls: ['./language-dropdown.component.css'],
})
export class LanguageDropdownComponent implements OnInit, OnDestroy {
  activeLang: any = {};
  languages: any[] = [];
  production = environment.production;
  private onDestroy$ = new Subject<void>();

  constructor(
    private languageService: LanguageService,
    private log: LoggerService,
    private route: ActivatedRoute,
  ) {
    Object.keys(languages).forEach((ln) => this.languages.push(languages[ln]));
  }

  ngOnInit() {
    const l = this.route.snapshot.data.l;

    if (l) {
      this.log.log('LanguageDropdown: l', l);
      this.languageService.setCurrent(l);
      this.activeLang = this.languages[l];
    }

    this.languageService
      .getCurrent()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((lang) => {
        this.log.log('LanguageDropdown: Current lang:', lang);
        this.activeLang = languages[lang];
      });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onChangeLang(lang: any) {
    this.languageService.setCurrent(lang.symbol);
    this.activeLang = lang;
  }
}
